import { __assign } from '../../../../_externals/.pnpm/tslib@2.7.0/node_modules/tslib/tslib.es6.js';
import '@emotion/react';
import styled from '@emotion/styled';
import tokens from '@lacedltd/design-tokens';
import { Label } from '../../../../_externals/.pnpm/@radix-ui_react-label@2.1.0_@types_react@18.3.5_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@radix-ui/react-label/dist/index.js';
import { Root, Thumb } from '../../../../_externals/.pnpm/@radix-ui_react-switch@1.1.0_@types_react@18.3.5_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@radix-ui/react-switch/dist/index.js';
import TypographyStyles from '../Typography/TypographyStyles.js';

var SwitchContainer = styled.div({
    height: "48px",
    position: "relative",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
});
var SwitchLabel = styled(Label)(function (_a) {
    var type = _a.type;
    return (__assign(__assign(__assign(__assign({}, (type === "body" && TypographyStyles.body)), (type === "footnote" && TypographyStyles.footnote)), (type === "caption" && TypographyStyles.caption)), { fontFamily: tokens.fontFamilies.primary, margin: "0 ".concat(tokens.spacing[3], " 0 0") }));
});
var SwitchRail = styled(Root, {
    shouldForwardProp: function (prop) { return !["darkMode", "variant"].includes(prop); },
})(function (_a) {
    var variant = _a.variant, darkMode = _a.darkMode;
    var railStyleMap = {
        default: {
            backgroundColor: darkMode
                ? tokens.color.airJordan[500]
                : tokens.color.airJordan[300],
        },
        active: {
            backgroundColor: darkMode
                ? tokens.color.airForce[900]
                : tokens.color.airForce[100],
        },
        error: {
            backgroundColor: darkMode
                ? tokens.color.airPresto[900]
                : tokens.color.airPresto[100],
        },
    };
    return __assign({ height: "12px", width: "48px", borderRadius: "1000px", transition: "background-color 0.3s ease", padding: 0, position: "relative", cursor: "pointer", "&[data-disabled]": {
            backgroundColor: darkMode
                ? tokens.color.airJordan[700]
                : tokens.color.airJordan[200],
        } }, railStyleMap[variant]);
});
var SwitchDot = styled(Thumb, {
    shouldForwardProp: function (prop) { return !["darkMode", "variant"].includes(prop); },
})(function (_a) {
    var variant = _a.variant, darkMode = _a.darkMode;
    var dotStyleMap = {
        default: {
            backgroundColor: darkMode
                ? tokens.color.airJordan[50]
                : tokens.color.airJordan[500],
        },
        active: {
            backgroundColor: darkMode
                ? tokens.color.airForce[300]
                : tokens.color.airForce.p,
        },
        error: {
            backgroundColor: darkMode
                ? tokens.color.airPresto[400]
                : tokens.color.airPresto.p,
        },
    };
    return __assign(__assign({ display: "block", position: "absolute", top: "-50%", height: "24px", width: "24px", backgroundColor: tokens.color.airJordan[500], transition: "background-color 0.3s ease, transform 0.3s ease", borderRadius: "50%", cursor: "pointer" }, dotStyleMap[variant]), { '&[data-state="checked"]': { transform: "translateX(24px)" }, "&[data-disabled]": {
            backgroundColor: darkMode
                ? tokens.color.airJordan[500]
                : tokens.color.airJordan[300],
        } });
});

export { SwitchContainer, SwitchDot, SwitchLabel, SwitchRail };
//# sourceMappingURL=Switch.styles.js.map
